export const navItems = [
  {
    value: "Overview",
    path: "overview",
  },
  {
    value: "Trend Viability",
    path: "trend-viability",
  },
  {
    value: "Review Tracker",
    path: "review-tracker",
  },
  {
    value: "Social",
    path: "social",
  },
  {
    value: "Google Ads",
    path: "google-ads",
  },
  {
    value: "FB Ads",
    path: "fb-ads",
  },
  {
    value: "Traffic and Revenue",
    path: "traffic-and-revenue",
  },
  {
    value: "Products",
    path: "products",
  },
];
